import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Power: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M12 2v10' }],
    ['path', { d: 'M18.4 6.6a9 9 0 1 1-12.77.04' }],
  ],
];

export default Power;
